/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import { formatPrice } from '@/model/utils/formatPrice'

const entity = {
  startsAt: {
    type: IKDataEntity.Types.Date
  },
  endsAt: {
    type: IKDataEntity.Types.Date
  },
  DOCount: {
    displayName: 'orderCount'
  },
  totalPersonCount: {
    displayName: 'Customers'
  },
  sumTotalPrice: {
    type: IKDataEntity.Types.Float
  },
  sumTipIncome: {
    type: IKDataEntity.Types.Float
  },
  taxInfo: {
    displayName: 'tax'
  }
}
const config = {

  load: async function (filter) {
    console.log(filter, 'filter')
    const [fromDate, toDate] = filter[0].dateFilter
    const res = (await hillo.get('BackendData.php?op=getDayReportV2', {
      fromDate,
      toDate
    })).content
    res.forEach(it => {
      it.taxInfo = it.taxInfo.map(it => (it.taxRate * 100).toFixed(2) + '%:' + formatPrice(it.sumTi)).join(' | ')
    })
    console.log(res, 'res')
    return res
  }

}

export default IKDataEntity.ModelFactory(entity, config)
